import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  CUSTOMER_TYPE,
} from '@savgroup-front-common/types';
import { AuthConfiguration } from '@/configuration';

interface GetSellerPartnersAgrs {
  clientId: string;
}

interface SellerPartner {
  sellerId: string;
  sellerName: string;
  customerType?: CUSTOMER_TYPE;
}

const getSellerPartners = async ({
  clientId,
}: GetSellerPartnersAgrs): Promise<
  BackResponse<SellerPartner[]> | BackResponseFailure
> => {
  const ENDPOINT = `${AuthConfiguration.authority}/api/client/sellerPartners`;

  try {
    return await apiCall<BackResponse<SellerPartner[]>>(
      buildUrl(ENDPOINT, {
        clientId,
      }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getSellerPartners;
